<template>
  <article class="queue-up-confirm-page">
    <v-row justify="center">
      <v-col cols="12"
             sm="12"
             md="4">
        <h3 class="font-weight-light" v-html="QUEUE_UP_CONFIRM_DATA.confirmText"/>
          <v-form
            v-on:submit.prevent="formSubmit"
            class="mt-5"
            ref="form">
          <v-text-field v-for="(field, i) in fields"
                        :key="i"
                        :class="`queue-up-confirm-page_${field.name}_input`"
                        :label="field.name"
                        v-model="form[field.name]"/>
          <v-btn
              @click="formSubmit"

              class="mr-4 w-100 white--text"
          >
            {{ QUEUE_UP_CONFIRM_DATA.confirmButtonText || 'Confirm'}}
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </article>
</template>

<script>
import {mapGetters} from "vuex";


export default {
  name: "Queue-Up-Confirm-Page",
  mounted() {
    this.$store.dispatch('GET_QUEUE_UP_CONFIRM_DATA', {
      tenantCode: this.$route.params.tenantCode,
      code: this.$route.params.code,
      uuid: this.$route.params.id,
    })
        .then(() => {
          this.setDynamicFormsFromAdditionalValues();
        })
  },
  computed: {
    ...mapGetters([
      'QUEUE_UP_CONFIRM_DATA',
    ]),
  },
  data: () => ({
    form: {},
    fields: [],
  }),
  methods: {
    formSubmit() {
      this.$store.dispatch('POST_QUEUE_UP_CONFIRM_DATA', {
        tenantCode: this.$route.params.tenantCode,
        code: this.$route.params.code,
        form: {
          uuid: this.$route.params.id,
          additional: {...this.form}
        }
      })
          .then(() => {
            this.$router.push({
              path: `/queue-up/status/${this.$route.params.tenantCode}/${this.$route.params.code}/${this.$route.params.id}`
            });
          })
    },
    setDynamicFormsFromAdditionalValues() {
      this.form = Object.assign(this.QUEUE_UP_CONFIRM_DATA.additional);

      for (const value in this.QUEUE_UP_CONFIRM_DATA.additional) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.QUEUE_UP_CONFIRM_DATA.additional.hasOwnProperty(value)) {
          this.fields.push({
            name: value
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
